const pickerOptions = {
    disabledDate(now) {
        let dateTime = new Date().getFullYear(); /* 获取现在的年份 */
        /* 前一年一号 */
        dateTime = new Date(dateTime - 1, 0, 1, 0, 0, 0)
        return now.getTime() < dateTime.getTime() || now.getTime() > Date.now()
    },
}

const CollectionTableTitle = [
    {
        prop: "idx",
        label: "序号",
        width: "50",
    },
    {
        prop: "rootName",
        label: "层级名称",
        width: "120",
    },
    {
        prop: "meterName",
        label: "设备名称",
        width: "120",
    },
    {
        prop: "inmeterno",
        label: "资产号",
        width: "120",
    },
    {
        prop: "amount",
        label: "充值金额3",
        width: "100",
    },
    {
        prop: "payType",
        label: "支付方式",
        width: "100",
    },
    {
        prop: "kwh",
        label: "剩余额度",
        width: "100",
    },
    {
        prop: "createTime",
        label: "交易时间",
        width: "120",
    },
]
export { pickerOptions, CollectionTableTitle }
